import React from 'react';
import { Box, Typography } from '@mui/material';
import TLIndividualLiveFeed from '../TLIndividualLiveFeed';

/**
 * MBF Live Simulation Tab
 * Wrapper around TLIndividualLiveFeed for organization-wide view
 */
const MBFLiveSimulationTab = ({ selectedTL }) => {
    const activeSiteId = Number(selectedTL) || 1;

    return (
        <Box>
            {!selectedTL && (
                <Box sx={{ mb: 3, p: 2, bgcolor: '#fff4e5', borderRadius: '12px', border: '1px solid #ffe2b9' }}>
                    <Typography sx={{ color: '#663c00', fontWeight: 500 }}>
                        Showing Live Feed for site #1 (Default). Select a specific TL from the dropdown to monitor another site.
                    </Typography>
                </Box>
            )}
            <TLIndividualLiveFeed siteId={activeSiteId} />
        </Box>
    );
};

export default MBFLiveSimulationTab;
